/* 孫吳傳・第 12 章：黃蓋火船（建安十三年，208）
 * 史實：《三國志·周瑜傳》黃蓋說「今寇衆我寡，難與持久。然觀操軍船艦首尾相接，可燒而走也」，於是「取蒙衝鬭艦數十艘，
 *       實以薪草，膏油灌其中，裹以帷幕，上建牙旗，先書報曹公，欺以欲降。又豫備走舸，各繫大船後，因引次俱前。
 *       曹公軍吏士皆延頸觀望，指言蓋降。蓋放諸船，同時發火。時風盛猛，悉延燒岸上營落。」
 *       《江表傳》（裴注）：「去北軍二里餘，同時發火。」
 * 流程：操作黃蓋，率十艘插著牙旗的火船從南岸出發。曹軍有「疑心」：偏離航道、出手、船隊散開都會讓疑心上升，滿了就被識破（戰敗）。
 *       東南風起後北上，過了「二里線」停船發火；火船順風撞進首尾相接的船陣，火延燒到岸上營落 → 換走舸撤回南岸。
 * 招式環節：開場曹軍半信半疑（疑心 45%）。等風的時候放 Q 苦肉計（自笞扣血），曹軍的探子看見，疑心大降。
 *       苦肉計是演義（正史只有「先書報曹公，欺以欲降」），借黃蓋的招式名用在這裡，簡報裡註明。
 * 這是第 11 章「火船・落水」的第一幕（def.next）：打完接落水呼韓當，評星看兩幕。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS } from '../kit.ts';
import { SHORE_N, CHAIN_Y, CHAIN, LINE_Y, SOUTH_Y } from '../maps/chibi.ts';

const LV = 11, START = [4600, 3450], LANE = 4600, WIND_T = 14, SAFE_Y = 3500;
const FLEET = [[-180, 90], [180, 90], [-360, 180], [360, 180], [-540, 270], [540, 270], [-180, 300], [180, 300], [0, 200]]; // 其他九艘的隊形（相對黃蓋）
const fake = (x, y) => ({ x, y, f: 1, alive: true, input: {}, fake: true }); // 船上沒有要打的人：只畫船

export default {
  id: 'sunwu-12', map: 'chibi', hero: 'huanggai',
  next: 'sunwu-13', // 第二幕：落水呼韓當（評星在第二幕）
  title: '第 11 章　火船・落水（上）', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '今寇衆我寡，難與持久。然觀操軍船艦首尾相接，可燒而走也。', src: '《三國志·吳書·周瑜傳》（黃蓋語）' }],
    text: '孫劉聯軍與曹軍隔江相持於赤壁。黃蓋看出曹軍船艦首尾相接，獻火攻之計，先寫信給曹操詐降，再率火船北上。（這一章借用演義「苦肉計」當招式環節，正史沒有這件事。）',
    goals: ['率火船北上，不要讓曹軍起疑（可以用苦肉計）', '東南風起後，過二里線停船發火', '換走舸撤回南岸', '（下半）落水呼韓當'],
  },
  words: { ally: '火船', foe: '曹軍' },
  // 能燒的：江上首尾相接的船陣，和北岸的營落
  fuel(m, x, y) { return (Math.abs(y - CHAIN_Y) < 160 && x > CHAIN[0] - 60 && x < CHAIN[1] + 60) || (y < SHORE_N + 60 && !SG.MAP.waterAt(x, y) && SG.MAP.walkable(x, y, 0)); },
  spreadMul(m, x, y) { return Math.abs(y - CHAIN_Y) < 160 ? 4 : 1.5; },
  // 評星在第二幕（sunwu-13）：疑心沒超過一半（susMax）、火燒到岸上營落（shore）
  steps: [
    { // 1. 詐降北上：等東南風
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.sus = 45; V.susMax = 45; V.hit = 0;
        V.b = m.boat(me, { x: START[0], y: START[1], sp: 120, flag: '#c0302a', fire: true, col: '#6a4a2c' });
        V.fleet = FLEET.map(([dx, dy]) => m.boat(fake(START[0] + dx, START[1] + dy), { x: START[0] + dx, y: START[1] + dy, sp: 135, flag: '#c0302a', fire: true, off: [dx, dy] }));
        // 曹軍的船陣：江北首尾相接
        V.chain = [];
        for (let x = CHAIN[0]; x <= CHAIN[1]; x += 300) V.chain.push(m.boat(fake(x, CHAIN_Y), { x, y: CHAIN_Y, big: true, flag: '#3b5a99', col: '#4a3a28', chain: true }));
        V.archers = Array.from({ length: 10 }, (_, i) => m.foe('huangjin', 2600 + i * 450, SHORE_N - 120, { spec: TROOPS.wei, name: '曹軍', hp: 600, maxHp: 600 }));
        m.card('先書報曹公，欺以欲降。', '《周瑜傳》');
        m.line('黃蓋', '船上滿是薪草膏油，插起牙旗，裝作來降。慢慢北上，別讓曹軍起疑。');
        m.after(5, () => m.line('提示', '右鍵點江面划船。偏離航道（地上的虛線）、出手打人、船隊散開，曹軍的疑心都會上升；滿了就會被識破。'));
        m.after(10, () => { if (!V.kurou) { m.line('黃蓋', '曹操多疑，一封信未必騙得過他……'); m.after(3, () => !V.kurou && m.line('提示', '在曹軍探子的眼前放 Q 苦肉計（鐵鞭自笞），疑心會大降。')); } });
        m.obj('sus', '');
        m.obj('wind', '等東南風');
        m.mark('line', LANE, LINE_Y, '二里線');
      },
      tick(m, w) {
        if (m.t < WIND_T) return false;
        m.wind = [-0.25, -0.97];
        m.card('時東南風急。', '《江表傳》（裴注）');
        m.big('東南風起！');
        m.done('wind');
        return true;
      },
    },
    { // 2. 引次俱前：到二里線停船發火
      enter(m) {
        m.line('黃蓋', '風起了！引次俱前！');
        m.obj('go', '過了二里線，停船發火');
        m.after(6, () => m.line('曹軍', '是黃公覆來降了！'));
        m.after(10, () => m.card('曹公軍吏士皆延頸觀望，指言蓋降。', '《周瑜傳》'));
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (V.b.y < LINE_Y && V.b.still > 0.4) m.chanAt(me, 'fire', V.b.x, V.b.y, 9999, 1.2, '發火', () => { V.lit = true; }, { hurt: false }); // 過了二里線、船停住才能發火
        return !!V.lit;
      },
    },
    { // 3. 同時發火：火船順風撞進船陣
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('go'); m.unmark('line');
        m.big('同時發火！');
        m.card('蓋放諸船，同時發火。', '《周瑜傳》');
        for (const b of [V.b, ...V.fleet]) { b.burning = true; }
        // 黃蓋換到走舸：大船留給火
        const old = V.b;
        V.fleet.push(m.boat(fake(old.x, old.y), { x: old.x, y: old.y, sp: 135, flag: '#c0302a', fire: true, burning: true, off: [0, 0] }));
        m.unboat(old);
        V.b = m.boat(me, { x: old.x, y: old.y + 120, sp: 230, small: true, flag: null, col: '#7a5634' });
        for (const b of V.fleet) { b.goal = [b.x + m.wind[0] * 1600, CHAIN_Y]; b.sp = 160; }
        m.obj('back', '換走舸，撤回南岸');
        m.mark('south', LANE, SAFE_Y + 100, '南岸');
        m.after(3, () => m.line('提示', '黃蓋換到繫在火船後面的走舸。往南划回去，曹軍會放箭。'));
      },
      tick(m, w) {
        const V = m.vars;
        return V.b.y > SAFE_Y;
      },
    },
    { // 4. 時風盛猛，悉延燒岸上營落
      enter(m, w) {
        m.done('back'); m.unmark('south');
        m.card('時風盛猛，悉延燒岸上營落。', '《周瑜傳》');
        m.after(5, () => m.card('蓋爲流矢所中，時寒墮水……', '《吳書》（裴注）'));
        m.after(9, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('黃蓋陣亡'); return; }
    if (!V.b) return;
    // 火船隊形：跟著黃蓋的船（還沒發火時）
    if (!V.lit) for (const b of V.fleet) b.goal = [V.b.x + b.off[0], V.b.y + b.off[1]];
    // 疑心：偏離航道、出手、船隊散開都會上升；慢慢回落。發火之後就不用裝了
    if (!V.lit) {
      // 苦肉計：自笞扣血，探子回報「真降」
      if (!V.kurou && me.cd[0] > 0) { V.kurou = true; V.kurouT = w.t; V.sus = Math.max(0, V.sus - 40); m.line('曹軍探子', '黃蓋渾身是血……看來是真的被打了，真心來降！'); }
      let up = 0;
      if (Math.abs(V.b.x - LANE) > 320) up += 9;
      if (me.act && !(V.kurouT && w.t - V.kurouT < 1.5)) up += 30;
      if (V.fleet.some((b) => SG.gd(b.x, b.y, V.b.x + b.off[0], V.b.y + b.off[1]) > 380)) up += 5;
      if (V.b.y < LINE_Y - 380) up += 14; // 靠太近了
      V.sus = Math.max(0, Math.min(100, V.sus + (up ? up : -3) * dt));
      V.susMax = Math.max(V.susMax, V.sus);
      const o = m.get('sus'); if (o) o.text = `曹軍的疑心：${Math.round(V.sus)}%`;
      if (V.sus >= 100) { m.lose('曹軍識破了詐降'); return; }
    } else { const o = m.get('sus'); if (o) { m.done('sus'); o.text = '曹軍已無暇他顧'; } }
    // 燒起來的火船（火畫在船上）：撞到船陣就點著船陣
    for (const b of V.fleet) {
      if (!b.burning) continue;
      if (!b.hit && Math.abs(b.y - CHAIN_Y) < 160) { b.hit = true; V.hit++; for (const dx of [-120, 0, 120]) m.fire(b.x + dx, CHAIN_Y, { dps: 110 }); }
    }
    for (const c of m.fires.values()) if (c.y < SHORE_N + 60 && !SG.MAP.waterAt(c.x, c.y)) { if (!V.shore) { V.shore = true; m.line('曹軍', '岸上的營也燒起來了！快逃啊！'); } break; }
    // 撤退時的箭：往走舸射
    if (V.lit && m.i === 2) {
      V.arrowT = (V.arrowT || 0) - dt;
      if (V.arrowT <= 0) { V.arrowT = 1.2; const g = V.b.goal || [V.b.x, V.b.y]; m.strike(V.b.x + (g[0] - V.b.x) * 0.25 + (SG.rand() - 0.5) * 160, V.b.y + (g[1] - V.b.y) * 0.25 + (SG.rand() - 0.5) * 100, 110, 1.1, 60, 0); }
    }
  },
};
